export default "__VITE_ASSET__DI5Uc6bl__"